import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import DistributionListManager from '../distribution/DistributionListManager';
import DistributionManager from '../distribution/DistributionManager';
import NewsPanel from '../news/NewsPanel';
import ProgramDetail from './ProgramDetail';
import ProgramItem from './ProgramItem';
import ProgramPanel from './ProgramPanel';

function ProgramPage({ isActive }) {
  const { openProgramDetail, navigationContext, openResourceDetail } = useNavigationContext();
  const { accountContext } = useAccountContext();
  const [programList, setProgramList] = useState([]);
  const [programDetail, setProgramDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [newsManagerIsOpen, setNewsManagerIsOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(undefined);
  const [distributionListManagerIsOpen, setDistributionListManagerIsOpen] = useState(false);
  const [distributionManagerIsOpen, setDistributionManagerIsOpen] = useState(false);
  const [distribution, setDistribution] = useState(undefined);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchProgramList();
  }, []);

  const fetchProgramList = async () => {
    await privateFetch('GET', 'melismes', `/cu/${accountContext.id}/program/`).then((res) => {
      setProgramList(res);
    });
  };

  const handleClickProgram = (program) => {
    openProgramDetail(program);
  };

  const handleClickResource = (resource) => {
    openResourceDetail(resource);
  };

  useEffect(() => {
    if (navigationContext.acitveProgramId) {
      fetchProgramDetail();
    } else setProgramDetail(undefined);
  }, [navigationContext]);

  const fetchProgramDetail = async () => {
    await privateFetch(
      'GET',
      'melismes',
      `/cu/${accountContext.id}/program/${navigationContext.acitveProgramId}/`
    ).then((res) => {
      if (res) setProgramDetail(res);
    });
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const createProgram = async (programForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'melismes',
      `/cu/${accountContext.id}/program/`,
      'Le programme a bien été ajouté',
      JSON.stringify(programForm)
    ).then(() => {
      fetchProgramList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateProgram = async (programForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'melismes',
      `/cu/${accountContext.id}/program/${programDetail.id}/`,
      'Le programme a bien été modifié',
      JSON.stringify(programForm)
    ).then(() => {
      fetchProgramList();
      setPanelIsOpen(false);
      fetchProgramDetail(programDetail.id);
      setLoading(false);
    });
  };

  const deleteProgram = async (program) => {
    await privateFetch(
      'DELETE',
      'melismes',
      `/cu/${accountContext.id}/program/${program.id}/`,
      'Le programme a bien été supprimé'
    ).then(() => {
      fetchProgramList();
      setProgramDetail(undefined);
    });
  };

  const createDistribution = async (distributionForm) => {
    await privateFetch(
      'POST',
      'melismes',
      `/cu/${accountContext.id}/program/${programDetail.id}/distribution/`,
      'La distribution a bien été ajoutée',
      JSON.stringify(distributionForm)
    ).then(() => {
      fetchProgramDetail();
    });
  };

  const updateDistribution = async (distributionForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'melismes',
      `/cu/${accountContext.id}/distribution/${distribution.id}/`,
      'La distribution a bien été modifiée',
      JSON.stringify(distributionForm)
    ).then(() => {
      fetchProgramList();
      setPanelIsOpen(false);
      setDistributionManagerIsOpen(false);
      fetchProgramDetail(programDetail.id);
      setLoading(false);
    });
  };

  const deleteDistribution = async (distribution) => {
    await privateFetch(
      'DELETE',
      'melismes',
      `/cu/${accountContext.id}/distribution/${distribution.id}/`,
      'La distribution a bien été supprimée'
    ).then(() => {
      fetchProgramDetail();
    });
  };

  const handleDistributionOrderChange = async (distributions) => {
    const payload = distributions.map((d, index) => ({
      ...d,
      order: index
    }));
    await privateFetch(
      'PUT',
      'melismes',
      `/cu/${accountContext.id}/program/${programDetail.id}/distribution/`,
      "L'ordre de la distribution a bien été modifié",
      JSON.stringify(payload)
    ).then(() => {
      fetchProgramDetail();
    });
  };

  const handleCreateNews = () => {
    setSelectedNews(undefined);
    setNewsManagerIsOpen(true);
  };

  const handleUpdateNews = (news) => {
    setSelectedNews(news);
    setNewsManagerIsOpen(true);
  };

  const createProgramNews = async (newsForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'melismes',
      `/cu/${accountContext.id}/program/${programDetail.id}/news/`,
      "L'article a bien été enregistré",
      JSON.stringify(newsForm)
    ).then(() => {
      fetchProgramDetail();
      setLoading(false);
      setNewsManagerIsOpen(false);
    });
  };

  const updateNews = async (newsForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/news/${selectedNews.id}/`,
      "L'article a bien été modifié",
      JSON.stringify(newsForm)
    ).then(() => {
      fetchProgramDetail();
      setLoading(false);
      setNewsManagerIsOpen(false);
    });
  };

  const handleDeleteNews = async (news) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/news/${news.id}/`,
      "L'article a bien été supprimé"
    ).then(() => {
      fetchProgramDetail();
      setSelectedNews(undefined);
    });
  };

  const goBackProgramAction = {
    onClick: handleClickProgram,
    icon: 'pi-chevron-left',
    label: 'Retour à la liste'
  };

  const newProgramAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un programme',
    icon: 'pi-plus'
  };

  const itemTemplate = (program) => (
    <ProgramItem program={program} handleClickProgram={() => handleClickProgram(program)} />
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Programmes"
        labelAction={handleClickProgram}
        action={programDetail ? goBackProgramAction : newProgramAction}
        detail={programDetail}>
        {!programDetail ? (
          <DataView value={programList} itemTemplate={itemTemplate} className="pb-20" />
        ) : (
          <ProgramDetail
            program={programDetail}
            handleUpdateProgram={handleOpenManager}
            handleUpdateDistribution={(distribution) => {
              setDistributionManagerIsOpen(true);
              setDistribution(distribution);
            }}
            handleUpdateDistributionList={() => setDistributionListManagerIsOpen(true)}
            handleDeleteDistribution={deleteDistribution}
            handleClickResource={handleClickResource}
            handleDelete={deleteProgram}
            handleCreateNews={handleCreateNews}
            handleUpdateNews={handleUpdateNews}
            handleDeleteNews={handleDeleteNews}
          />
        )}
      </PageWrapper>

      <ProgramPanel
        isOpen={panelIsOpen}
        loading={loading}
        program={programDetail}
        onUpdate={updateProgram}
        onClose={setPanelIsOpen}
        onCreate={createProgram}
      />

      <DistributionListManager
        isOpen={distributionListManagerIsOpen}
        onClose={setDistributionListManagerIsOpen}
        createDistribution={createDistribution}
        handleOrderChange={handleDistributionOrderChange}
        updateDistribution={updateDistribution}
        distributions={programDetail?.distributions}
        loading={loading}
      />

      <DistributionManager
        isOpen={distributionManagerIsOpen}
        onClose={setDistributionManagerIsOpen}
        updateDistribution={updateDistribution}
        distribution={distribution}
        loading={loading}
      />

      <NewsPanel
        news={selectedNews}
        loading={loading}
        isOpen={newsManagerIsOpen}
        onClose={() => {
          setSelectedNews(null);
          setNewsManagerIsOpen(false);
        }}
        onCreate={createProgramNews}
        onUpdate={updateNews}
      />
    </div>
  );
}

export default ProgramPage;
